var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"mb-30",attrs:{"icon":"Person","title":_vm.$t('health_actions.details.assigned_to', [_vm.assignedNames]),"accentColor":"sky"}})
}
var staticRenderFns = []

export { render, staticRenderFns }